import React from 'react';
import { createPortal } from 'react-dom';
import { useToast } from '../../contexts/ToastContext';
import { useT } from '../../i18n/LocaleContext';

const ICONS = {
  success: '✓',
  error: '!',
  info: 'ℹ',
  warning: '⚠',
};

export default function ToastViewport() {
  const { toasts, remove } = useToast();
  const t = useT();

  if (!toasts.length) return null;

  return createPortal(
    <div className="toast-viewport" aria-live="polite" aria-atomic="true">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast toast--${toast.variant}`} role="status">
          <span className="toast-icon" aria-hidden>{ICONS[toast.variant] || '•'}</span>
          <div className="toast-body">
            <div className="toast-title">{toast.title || t(`toast.${toast.variant}`)}</div>
            {toast.message && <div className="toast-message">{toast.message}</div>}
          </div>
          <button
            type="button"
            className="toast-close"
            onClick={() => remove(toast.id)}
            aria-label={t('common.close')}
          >
            ×
          </button>
        </div>
      ))}
    </div>,
    document.body
  );
}
